import { Close } from "@mui/icons-material";
import { Box, CardMedia, IconButton, Typography } from "@mui/material";
import React, { useRef, useState } from "react";
import { AddImageToInputIcon } from "../../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/AddImageToInputIcon";

interface UploadImageProps {
  setUploadImage: (image: File | string | null) => void;
}

export const UploadImage = ({setUploadImage}:UploadImageProps) => {
  const [imageUploadURL, setImageUploadURL] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const openFileInput = () => {
    fileInputRef?.current?.click();
  };
  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };
  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    const file = event.dataTransfer.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageUploadURL(reader.result as string);
      };
      reader.readAsDataURL(file);
      setUploadImage(file); 
    }
  };
  const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageUploadURL(reader.result as string);
      };
      reader.readAsDataURL(file);
      setUploadImage(file); // Pass the file to the parent component
    }
  };
  const handleRemoveImage = () => {
    setImageUploadURL(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Clear the file input value
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
      }}
    >
      {imageUploadURL ? (
        <Box
          sx={{
            position: "relative",
            width: "160px",
            height: "160px",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          <CardMedia
            onDrop={handleDrop}
            onClick={openFileInput}
            component="img"
            image={imageUploadURL || ""}
            alt="Selected"
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "6px",
              zIndex: 1,
            }}
          />
          <IconButton
            className="delete-btn"
            onClick={handleRemoveImage}
            sx={{
              position: "absolute",
              top: "-15px",
              right: "-15px",
              backgroundColor: "rgba(62, 84, 96, 0.5)",
              opacity: 1,
              zIndex: 100,
              transition: "opacity 0.3s ease",
              "&:hover": {
                backgroundColor: "#3E5460",
              },
            }}
          >
            <Close
              sx={{
                color: "var(--Main_icons_color)",
                fontSize: "1rem",
              }}
            />
          </IconButton>
        </Box>
      ) : (
        <Box className="image-input" sx={{ width: "160px", height: "160px" }}>
          <Box onDragOver={handleDragOver} onDrop={handleDrop}>
            <Box
              onClick={openFileInput}
              sx={{
                width: "100%",
                height: "100%",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <AddImageToInputIcon />
              <Typography className="input-drop-title">Upload image</Typography>
              <Typography className="input-accept-note">
                Format: jpg & Max file size: 5 MB
              </Typography>
            </Box>
          </Box>
        </Box>
      )}
      <Typography
        sx={{
          color: "var(--M-background117)",
          fontFamily: "Roboto",
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: 400,
          opacity: 0.7,
        }}
      >
        Upload image to use it in different apps
      </Typography>
      <input
        type="file"
        id="image-input"
        ref={fileInputRef}
        accept="image/jpeg, image/png"
        style={{ display: "none" }}
        onChange={handleImageUpload}
      />
    </Box>
  );
};
